module.exports = __webpack_public_path__ + "static/media/bulle-savoir.87cbd987.png";